// navbar.js
import React from "react";
import logo from "../assets/img/logo.svg";
import "../styles/navbar.css";

const Navbar = () => {
    return (
        <nav>
            <div className="logo">
                <img src={logo} alt="Logo" />
            </div>
            <div className="menu">
                <a href="#sobre">Sobre</a>
                <a href="#projetos">Projetos</a>
                <a href="#conhecimentos">Conhecimentos</a>
                <a href="#contato">Contato</a>
            </div>
        </nav>
    );
};

export default Navbar;
